import React, { useState, memo } from 'react';
import { X, Check, ChevronDown, ChevronUp } from 'lucide-react';
export function UpsellSection() {
  const [openProject, setOpenProject] = useState<number | null>(null);
  const withoutUpsell = ['Explicás los temas por separado', 'El trabajo final lo tenés que armar vos', 'Los alumnos no ven "para qué sirve" todo junto', 'Cerrar el año es un caos de notas y entregas', 'El alumno egresa sin haber resuelto un problema real'];
  const withUpsell = ['Tus alumnos integran todo en un proyecto real', '3 proyectos completos listos para entregar', 'El alumno diseña e instala una obra completa', 'Todo el proyecto tiene criterios de evaluación incluidos', 'El egresado tiene experiencia de obra en el cuerpo'];
  const projects = [{
    title: 'Proyecto 1 — Vivienda Unifamiliar Completa',
    desc: 'Instalación eléctrica completa de una vivienda de 3 dormitorios con pileta, aire acondicionado y portero eléctrico. Incluye memoria de cálculo, plano de distribución de bocas, cómputo de materiales y tablero principal dimensionado.'
  }, {
    title: 'Proyecto 2 — Local Comercial con Automatización',
    desc: 'Instalación de un local de 80m² con iluminación de vidriera por fotocontrol, circuito de tomas especiales para equipos de refrigeración y tablero seccional con protecciones selectivas.'
  }, {
    title: 'Proyecto 3 — Tablero de Transferencia para Generador de Emergencia',
    desc: 'El proyecto de nivel industrial que diferencia a tus alumnos. Transferencia entre red y generador, señalización luminosa de estado, protecciones de motor y documentación técnica completa.'
  }];
  return <section className="py-10 md:py-16 px-4 bg-brand-dark" data-id="element-296">
      <div className="max-w-4xl mx-auto" data-id="element-297">
        <div className="text-center mb-10" data-id="element-298">
          <h2 className="text-2xl md:text-4xl font-black text-white mb-2" data-id="element-299">
            🔥 ¿QUÉ AGREGA EL UPSELL?
          </h2>
          <p className="text-lg md:text-xl font-bold text-brand-accent neon-glow" data-id="element-300">
            💣 "SISTEMA DE PROYECTOS FINALES INTEGRADORES ELÉCTRICOS"
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-301">
          {/* Sin Upsell */}
          <div className="bg-brand-card rounded-xl border border-red-500/30 p-6" data-id="element-302">
            <h3 className="text-xl font-black text-red-400 mb-6 flex items-center justify-center" data-id="element-303">
              <X className="w-6 h-6 mr-2" data-id="element-304" /> ❌ Sin Upsell
            </h3>
            <ul className="space-y-4" data-id="element-305">
              {withoutUpsell.map((item, i) => <li key={i} className="flex items-start" data-id="element-306">
                  <X className="w-5 h-5 text-red-500/70 mr-3 shrink-0 mt-0.5" data-id="element-307" />
                  <span className="text-gray-400 font-medium" data-id="element-308">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Con Upsell */}
          <div className="bg-brand-card rounded-xl border-2 border-brand-accent p-6 shadow-[0_0_15px_rgba(14,165,233,0.15)]" data-id="element-309">
            <h3 className="text-xl font-black text-brand-accent mb-6 flex items-center justify-center neon-glow" data-id="element-310">
              <Check className="w-6 h-6 mr-2" data-id="element-311" /> ✅ Con Upsell
            </h3>
            <ul className="space-y-4" data-id="element-312">
              {withUpsell.map((item, i) => <li key={i} className="flex items-start" data-id="element-313">
                  <Check className="w-5 h-5 text-brand-accent mr-3 shrink-0 mt-0.5" data-id="element-314" />
                  <span className="text-white font-bold" data-id="element-315">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mb-10" data-id="element-316">
          <h3 className="text-xl md:text-2xl font-black text-white text-center mb-6" data-id="element-317">
            🔌 LOS 3 PROYECTOS INTEGRADORES INCLUIDOS:
          </h3>
          <div className="space-y-3 max-w-3xl mx-auto" data-id="element-318">
            {projects.map((project, i) => <div key={i} className="bg-brand-card border border-white/10 rounded-xl overflow-hidden hover:border-brand-accent/30 transition-colors" data-id="element-319">
                <button onClick={() => setOpenProject(openProject === i ? null : i)} className="w-full p-4 md:p-5 text-left flex items-center justify-between focus:outline-none" data-id="element-320">
                  <span className={`text-lg font-bold ${openProject === i ? 'text-brand-accent' : 'text-white'}`} data-id="element-321">
                    {project.title}
                  </span>
                  {openProject === i ? <ChevronUp className="w-5 h-5 text-brand-accent shrink-0 ml-2" data-id="element-322" /> : <ChevronDown className="w-5 h-5 text-gray-600 shrink-0 ml-2" data-id="element-323" />}
                </button>
                <div className={`px-4 md:px-5 overflow-hidden transition-all duration-300 ease-in-out ${openProject === i ? 'max-h-48 pb-4 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-324">
                  <p className="text-sm md:text-base text-gray-400 leading-relaxed pt-2 border-t border-white/5" data-id="element-325">
                    {project.desc}
                  </p>
                </div>
              </div>)}
          </div>
        </div>

        <div className="text-center" data-id="element-326">
          <p className="text-xl md:text-2xl font-black text-white bg-brand-card inline-block px-6 py-3 rounded-lg border border-white/10" data-id="element-327">
            👉 Esto convierte tu cierre de año en una{' '}
            <span className="text-brand-accent neon-glow" data-id="element-328">
              EXPERIENCIA DE OBRA REAL
            </span>
          </p>
        </div>
      </div>
    </section>;
}